import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const PidsWrapper = lib.styled.div`
  margin: 15px;
  margin-top: 5px;
  background-color: ${colors.lightGray06};
  display: flex;
  align-items: center;
  justify-content: center;

  [class*="MuiLinearProgress-colorPrimary"] {
    background-color: ${colors.lightGray12}!important;
  }

  [class*="MuiLinearProgress-barColorPrimary"] {
    background-color: ${colors.lightBlue}!important;
  }
`;

export const BoxPids = lib.styled.div`
  display: ${props => (props.dashes ? 'flex' : 'none')}
  position: absolute;
  width: 295px;
  z-index: 9;
  align-items: center;
  justify-content: space-evenly;

  .pid{
    width: calc(6.5% - 10px);
    height: 17px;
    display: inline-block;
    background-color: ${colors.white02};
  }
`;
